<template>
  <h1>Quiz Active Page</h1>
  <div>
    <p>Time remaining: {{ formatTime(countdown) }}</p>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "QuizActivePage",
  data() {
    return {
      countdown: 300, // 300 seconds (5 minutes)
      timer: null,
    };
  },
  methods: {
    formatTime(seconds) {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;
      return `${minutes}:${
        remainingSeconds < 10 ? "0" : ""
      }${remainingSeconds}`;
    },
    startTimer() {
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(this.timer);
          // Handle quiz completion when the timer runs out
        }
      }, 1000); // Update the countdown every 1 second (1000 milliseconds)
    },
  },
  mounted() {
    this.startTimer(); // Start the timer when the component is mounted
  }
});
</script>

<style scoped></style>
